import { TitleHeader } from '../../../../../../Common/TitleHeader'
import {
  Button,
  DatePicker,
  Divider,
  FormTable,
  IconButton,
  Input,
  Typography
} from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '../../../../../../../Common/Grid'
import { URLS } from '../../../../../../constants'
import { ManageSearch as ManageSearchIcon } from '@mui/icons-material'
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getValidationSchema, initialValues } from './helpers'
import { useFormik } from 'formik'
import { useLocation, useNavigate } from 'react-router-dom'
import { useNotification } from '../../../../../../../../../hooks'
import AlertModal from '../../../../../../Common/AlertModal/AlertModal'
import { makeCoreGetRequest, makeCorePostRequest } from '../../../../../../../../../utils/api'
import { formatErrorMessage } from '../../../../../../../../../utils/formatting'
import { DefectReason, Mark, ScanStatus } from '../../../../../../../enums'
import { TextField, Autocomplete } from '@mui/material'
import ImageUpload from '../../../../../../Common/ImageUpload/ImageUpload'
import dayjs from 'dayjs'
import { validateScanCode } from "../../../../../../helpers";
import { findSelectedOption, toProductOptions } from "../../serializers";
import { makeScanAwareDecimalChange } from "../../DeliveryCompleteScan/DeliveryCompleteScanStep2/helpers";

const DeliveryRandomProductFinal = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()
  const location = useLocation()
  const support = location.state

  const markOptions = Object.keys(Mark).map(key => ({ value: key, label: Mark[key] }))
  const defectReasonOptions = Object.keys(DefectReason).map(key => ({
    value: key,
    label: DefectReason[key]
  }))

  const [isSgrProductsModalOpen, setIsSgrProductsModalOpen] = useState(false)
  const [sgrProductsModalContent, setSgrProductsModalContent] = useState({ title: '', listItems: [], buttons: [] })
  const [isProductScanModalOpen, setIsProductScanModalOpen] = useState(false)
  const [productScanModalContent, setProductScanModalContent] = useState({ title: '', description: '', buttons: [] })
  const [isEanNotPresentModalOpen, setIsEanNotPresentModalOpen] = useState(false)
  const [eanNotPresentModalContent, setEanNotPresentModalContent] = useState({ title: '', buttons: [] })
  const [isCodeAndEanNotPresentModalOpen, setIsCodeAndEanNotPresentModalOpen] = useState(false)
  const [codeAndEanNotPresentModalContent, setCodeAndEanNotPresentModalContent] = useState({ title: '', buttons: [] })
  const [isSgrMessageModalOpen, setIsSgrMessageModalOpen] = useState(false)
  const [sgrMessageModalContent, setSgrMessageModalContent] = useState({ title: '', buttons: [] })
  const [isConfirmFinaliseSupportModalOpen, setIsConfirmFinaliseSupportModalOpen] = useState(false)
  const [confirmFinaliseSupportModalContent, setConfirmFinaliseSupportModalContent] = useState({ title: '', buttons: [] })
  const [isWrongQuantitiesModalOpen, setIsWrongQuantitiesModalOpen] = useState(false)
  const [wrongQuantitiesModalContent, setWrongQuantitiesModalContent] = useState({ title: '', description: '', buttons: [] })
  const [isShortLifeModalOpen, setIsShortLifeModalOpen] = useState(false)
  const [shortLifeModalContent, setShortLifeModalContent] = useState({ title: '', description: '', buttons: [] })
  const [isWrongDlcAlertOpen, setIsWrongDlcAlertOpen] = useState(false)
  const [isMandatoryDlcAlertOpen, setIsMandatoryDlcAlertOpen] = useState(false)

  const [marks, setMarks] = useState([])
  const [defectReasons, setDefectReasons] = useState([])
  const [litigation, setLitigation] = useState(null)
  const [showModificaButton, setShowModificaButton] = useState(false)
  const [imageUploaded, setImageUploaded] = useState(false)
  const [confirmResponse, setConfirmResponse] = useState({ counter: 0, total: 0 })
  const [productScanResp, setProductScanResp] = useState<any>()
  const [showMarks, setShowMarks] = useState(false)
  const [showDefects, setShowDefects] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [inputValue, setInputValue] = useState("");
  const [scanCounter, setScanCounter] = useState(0)
  const isSubmittingRef = useRef(false)

  const validationSchema = useMemo(() => getValidationSchema(), [])
  const formik = useFormik({
    enableReinitialize: false,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values: any) => {
      try {
        const dlcDate = dayjs(values.dlc);
        const formattedDlc = (values.dlc && dlcDate.isValid())
          ? dlcDate.format('YYYY-MM-DD')
          : null;

        const mark = markOptions.find(option => option.label === values.mark)
        const defectReason = defectReasonOptions.find(
          option => option.label === values.defectReason
        )

        const product = {
          id: values.productId,
          name: values.productName,
          code: values.productCode,
          ean: values.productEans,
          eanReceived: values.eanReceived,
          unit: null,
          integral: parseFloat(values.currentConformQuantity) + parseFloat(formik.values.conform) || 0,
          broken: parseFloat(values.currentDefectQuantity) + parseFloat(formik.values.defect) || 0,
          quantity: values.quantity,
          shortDlc: values.shortDlc,
          dlc: formattedDlc,
          defectReason: defectReason?.value || null,
          mark: mark?.value || null,
          shopReceptionDeviation: values.shopReceptionDeviation,
          supportId: support.supportId
        }
        const resp = await makeCorePostRequest(
          `/shop-reception-mobile/aleatory/product/save`,
          product
        )

        if (resp.shortLifetime) {
          showShortLifeMessage(resp)
        } else {
          clearData()
          document.getElementById('scan-input').focus()

          if (resp.counter == null) {
            showNotification({
              message: 'Cantitaţile pentru produsul necomandat au fost înregistrate cu succes.',
              type: 'success'
            })
          } else {
            setConfirmResponse({ counter: resp.counter, total: resp.total })
            showNotification({
              message: 'Cantitaţile au fost înregistrate cu succes.',
              type: 'success'
            })
          }
        }
      } catch (error) {
        showNotification({
          message: `Error while submitting. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  })

  const confirmProduct = async () => {
    const productForm = formik.values
    let wrongDlc = false

    const currentConformValue = parseFloat(productForm.currentConformQuantity)
    const currentDefectValue = parseFloat(productForm.currentDefectQuantity)
    const oldConformValue = parseFloat(productForm.conform)
    const oldDefectValue = parseFloat(productForm.defect)
    const currentTotalValue =
      currentConformValue + oldConformValue + currentDefectValue + oldDefectValue

    if (productForm.showDlc && productForm.dlc == null) {
      setIsMandatoryDlcAlertOpen(true)
      return
    }

    const { dlc: entered, productDlc: original } = formik.values

    const formattedEntered = entered ? dayjs(entered).format('YYYY-MM-DD') : null

    if (
      currentConformValue > 0 &&
      productForm.showDlc &&
      productForm.shortDlc === true &&
      productForm.productDlc != null
    ) {
      if (formattedEntered !== original) {
        wrongDlc = true
      }
    }

    const deviation =
      productForm.shopReceptionDeviation === null ? 0 : productForm.shopReceptionDeviation / 1000
    if (
      productForm.quantity != null &&
      !(
        productForm.quantity - deviation <= currentTotalValue &&
        productForm.quantity + deviation >= currentTotalValue
      )
    ) {
      showWrongQuantitiesMessage(wrongDlc)
    } else if (wrongDlc) {
      setIsWrongDlcAlertOpen(true)
    } else {
      const errors = await formik.validateForm();
      if (Object.keys(errors).length) {
        showNotification({ message: Object.values(errors)[0] as string || 'Formular invalid.', type: 'error' });
        return;
      }

      formik.handleSubmit()
    }
  }

  const clearData = () => {
    setLitigation(null)
    setShowMarks(false)
    setShowDefects(false)
    setImageUploaded(false)
    setShowModificaButton(false)
    formik.resetForm()
    formik.setFieldValue('productCode', '')
    formik.setFieldValue('productName', '')
    formik.setFieldValue('productEans', '')
    document.getElementById('scan-input').focus()
  }

  const onFinalize = () => {
    showConfirmFinaliseSupport()
  }

  const doFinalise = async () => {
    if (isSubmittingRef.current) return

    isSubmittingRef.current = true
    setIsSubmitting(true)

    try {
      await makeCorePostRequest(
        `/shop-reception-mobile/aleatory/product/support/close/${support.truckId}`,
        { supportId: support.supportId },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).then(() => navigate(URLS.AUTH_DELIVERY_DETAIL, { state: support.truckId }))
    } catch (error) {
      showNotification({
        message: `Error while submitting. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    } finally {
      isSubmittingRef.current = false
      setIsSubmitting(false)
    }
  }

  const modifyQuantities = () => {
    navigate(URLS.AUTH_DELIVERY_RANDOM_PRODUCT_CONFIRM, {
      state: {
        productId: formik.values.productId,
        supportId: support.supportId,
        truckId: support.truckId,
        flow: 'aleatory_product',
        quantity: formik.values.quantity
      }
    })
  }

  const showConfirmFinaliseSupport = () => {
    setConfirmFinaliseSupportModalContent({
      title: `Au fost verificate ${
        support?.productCounter > confirmResponse?.counter
          ? support?.productCounter
          : confirmResponse?.counter
      } produse de pe suport!`,
      buttons: [
        {
          label: 'Mai verific',
          onClick: () => {
            setIsConfirmFinaliseSupportModalOpen(false)
            setTimeout(() => {
              document.getElementById('scan-input').focus()
            }, 0)
          },
          color: 'primary',
          disabled: isSubmitting
        },
        {
          label: 'Am terminat',
          onClick: () => {
            doFinalise()
            setIsConfirmFinaliseSupportModalOpen(false)
          },
          color: 'primary',
          disabled: isSubmitting
        }
      ]
    })
    setIsConfirmFinaliseSupportModalOpen(true)
  }

  const closeConfirmFinaliseSupport = () => {
    setIsConfirmFinaliseSupportModalOpen(false)
  }

  useEffect(() => {
    if (support?.sgrProductsList?.length > 0) {
      let sgrProducts: string[] = []

      support?.sgrProductsList?.forEach(product => {
        sgrProducts?.push(product.name)
      })

      showSgrProductsList(sgrProducts)
    }
  }, [support])

  useEffect(() => {
    if (support?.productEan) {
      formik.setFieldValue('productCode', support.productEan)
      productScan(support?.supportId, support?.productEan)
    }
  }, [support])

  const productScan = (supportId, productCode) => {
    try {
      makeCoreGetRequest(
        `/shop-reception-mobile/aleatory/product/scan-by-code/${supportId}/${productCode}`,
        null
      ).then(resp => {
        const scanOk = resp.scanSuccess
        const mess = resp.errorMessage
        const scanStatus = resp.scanStatus
        setShowModificaButton(resp.alreadyScanned)

        if (scanOk !== true) {
          formik.setValues({
            productName: '',
            productEans: '',
            productId: null,
            productDlc: null
          })
          showProductScanMessage(mess)
        } else if (ScanStatus.CODE_AND_EAN_NOT_PRESENT === scanStatus) {
          showCodeAndEanNotPresentConfirmation(resp)
        } else if (ScanStatus.EAN_NOT_PRESENT === scanStatus) {
          showEanNotPresentConfirmation(resp)
        } else {
          if (resp.sgr) {
            showSgrMessage()
          }
          populateScanInfo(resp)
          formik.setFieldValue('bulkProductCode', '')
        }
        setProductScanResp(resp)
        setScanCounter(prev => prev + 1)
      })
    } catch (error) {
      showNotification({
        message: `Error while scanning product. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const productScanById = id => {
    try {
      makeCoreGetRequest(
        '/shop-reception-mobile/aleatory/product/scan-by-id/' + support.supportId + '/' + id,
        null
      ).then(resp => {
        const scanOk = resp.scanSuccess
        const mess = resp.errorMessage
        const scanStatus = resp.scanStatus
        setShowModificaButton(resp.alreadyScanned)

        if (scanOk !== true) {
          formik.setValues({
            productName: '',
            productEans: '',
            productId: null,
            productDlc: null
          })
          showProductScanMessage(mess)
        } else if (ScanStatus.CODE_AND_EAN_NOT_PRESENT === scanStatus) {
          showCodeAndEanNotPresentConfirmation(resp)
        } else if (ScanStatus.EAN_NOT_PRESENT === scanStatus) {
          showEanNotPresentConfirmation(resp)
        } else {
          if (resp.sgr) {
            showSgrMessage()
          }
          populateScanInfo(resp)
        }
        setProductScanResp(resp)
        setScanCounter(prev => prev + 1)
      })
    } catch (error) {
      showNotification({
        message: `Error while scanning product. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  useEffect(() => {
    calculateLitigationType()
  }, [
    formik.values.currentConformQuantity,
    formik.values.currentDefectQuantity,
    formik.values.conform,
    formik.values.defect,
    formik.values.quantity,
    formik.values.shopReceptionDeviation,
    scanCounter
  ])

  useEffect(() => {
    if (productScanResp?.scanSuccess && scanCounter > 0) {
      setTimeout(() => {
        document.getElementById("current-conform-input")?.focus()
      }, 0)
    }
  }, [scanCounter, productScanResp])

  const calculateLitigationType = () => {
    const currentConformValue = parseFloat(formik.values.currentConformQuantity)
    const currentDefectValue = parseFloat(formik.values.currentDefectQuantity)
    const oldConformValue = parseFloat(formik.values.conform)
    const oldDefectValue = parseFloat(formik.values.defect)
    const totalConform = oldConformValue + currentConformValue
    const totalValue = oldConformValue + oldDefectValue + currentConformValue + currentDefectValue
    const deviation = !formik.values.shopReceptionDeviation ? 0
      : formik.values.shopReceptionDeviation / 1000

    const qty = formik.values.quantity;

    if (qty == null) {
      setLitigation(null);
      setShowMarks(false);
      setShowDefects(false);
      formik.setFieldValue('mark', '');
      formik.setFieldValue('defectReason', '');
      return;
    }

    if (
      formik.values.quantity > totalConform + deviation &&
      formik.values.quantity === totalValue
    ) {
      setMarks([
        Mark.VEGETABLE_FRUIT_QUALITY,
        Mark.EXPIRED,
        Mark.SHORT_TERM,
        Mark.DAMAGED,
        Mark.VEGETABLES_FRUITS,
        Mark.DETERIORATION_A
      ])

      setLitigation(2)
      setShowMarks(true)
    } else if (
      formik.values.quantity > totalConform + deviation &&
      formik.values.quantity !== totalValue
    ) {
      setMarks([
        Mark.PALLETS_MERCHANDISE_MISSING,
        Mark.MISSING_CARRIER,
        Mark.QUANTITATIVE_DIFFERENCE
      ])

      setLitigation(1)
      setShowMarks(true)
    } else if (formik.values.quantity < totalConform - deviation) {
      setMarks([Mark.PALLETS_MERCHANDISE_MISSING, Mark.QUANTITATIVE_DIFFERENCE])

      setLitigation(1)
      setShowMarks(true)
    } else if (
      formik.values.quantity - deviation <= totalConform &&
      totalConform <= formik.values.quantity + deviation
    ) {
      setLitigation(null)
      setShowMarks(false)
      setShowDefects(false)
    }

    formik.setFieldValue('mark', '')
    formik.setFieldValue('defectReason', '')
  }

  const populateDefectReasons = selectedMark => {
    if (formik.values.mark) {
      formik.setFieldValue('defectReason', '')

      switch (litigation) {
        case 1:
          setDefectReasons([DefectReason.PROVIDER])
          formik.setFieldValue('defectReason', DefectReason.PROVIDER)
          break
        case 2:
          if (selectedMark === Mark.EXPIRED || selectedMark === Mark.SHORT_TERM) {
            setDefectReasons([DefectReason.PROVIDER])
            formik.setFieldValue('defectReason', DefectReason.PROVIDER)
          } else if (selectedMark === Mark.VEGETABLE_FRUIT_QUALITY) {
            setDefectReasons([DefectReason.PROVIDER, DefectReason.SHOP])
          } else if (selectedMark === Mark.DAMAGED) {
            setDefectReasons([DefectReason.PROVIDER, DefectReason.TRANSPORTER, DefectReason.SHOP])
          } else if (
            selectedMark === Mark.VEGETABLES_FRUITS ||
            selectedMark === Mark.DETERIORATION_A
          ) {
            setDefectReasons([DefectReason.PROVIDER, DefectReason.TRANSPORTER])
          }
          break
        default:
          setDefectReasons([])
      }
    }
  }

  useEffect(() => {
    populateDefectReasons(formik.values.mark)
  }, [formik.values.mark])

  const populateScanInfo = resp => {
    const conform = resp.validated === null ? 0 : resp.validated
    const defect = resp.broken === null ? 0 : resp.broken
    const deviation = resp.shopReceptionDeviation ? resp.shopReceptionDeviation : 0

    setShowMarks(false)
    setShowDefects(false)

    formik.setValues({
      productCode: '',
      productName: resp.productName,
      productEans: resp.productEans,
      productDlc: resp.dlc,
      productId: resp.productId,
      quantity: resp.quantity ?? null,
      eanReceived: resp.eanReceived,
      shopReceptionDeviation: deviation,
      alreadyScanned: !!resp.alreadyScanned,
      conform: conform,
      defect: defect,
      dlc: resp.dlc,
      shortDlc: resp.shortDlc,
      defectReason: resp.defectReason,
      mark: resp.mark,
      currentConformQuantity: support?.currentConformQuantity || 0,
      currentDefectQuantity: support?.currentDefectQuantity || 0,
      showDlc: resp.dlc !== null || resp.shortDlc === true
    })
  }

  const handleSuccess = () => {
    showNotification({
      message: 'Imaginea a fost încărcată cu succes.',
      type: 'success'
    })

    setImageUploaded(true)
  }

  const handleError = error => {
    showNotification({
      message: `${formatErrorMessage(error)}`,
      type: 'error'
    })
  }

  const productOptions = useMemo(
    () => toProductOptions(support?.productList),
    [support?.productList]
  );

  const selectedOption = useMemo(
    () => findSelectedOption(productOptions, formik.values.bulkProductCode),
    [productOptions, formik.values.bulkProductCode]
  );

  const onScan = useCallback((code: string) => {
    clearData()
    if (validateScanCode(showNotification, code, 'produs')) {
      productScan(support.supportId, code)
    }
    setTimeout(() => document.getElementById('scan-input')?.focus(), 50)
  }, [clearData, showNotification, productScan])

  const scanDecimalChange = useMemo(
    () => makeScanAwareDecimalChange(formik.setFieldValue, { threshold: 5, onScan, getValue: (f) => (formik.values as any)[f] }),
    [formik.setFieldValue, onScan, formik.values]
  )

  const handleConformChange = scanDecimalChange('currentConformQuantity')
  const handleDefectChange  = scanDecimalChange('currentDefectQuantity')

  const columns = [
    {
      title: 'Produs',
      field: 'product',
      align: 'left',
      render: (rowData: any) => (
        <span style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {rowData.productName}
          <br />
          {rowData.productEans}
        </span>
      )
    },
    {
      title: 'Calitativ',
      field: 'qualitative',
      align: 'left',
      render: (rowData: any) => (
        <Input
          type="number"
          value={rowData.qualitative || 0}
          onChange={handleConformChange}
          id="current-conform-input"
          variant="standard"
          style={{ minWidth: '55px' }}
        />
      )
    },
    {
      title: 'Defect',
      field: 'defective',
      align: 'left',
      render: (rowData: any) => (
        <div style={{ display: 'flex' }}>
          <Input
            type="number"
            value={rowData.defective || 0}
            onChange={handleDefectChange}
            variant="standard"
            style={{ minWidth: '55px' }}
          />
        </div>
      )
    }
  ]

  const rows = [
    {
      productName: formik.values.productName,
      productEans: formik.values.productEans,
      qualitative: formik.values.currentConformQuantity,
      defective: formik.values.currentDefectQuantity
    }
  ]

  const showWrongQuantitiesMessage = wrongDlc => {
    setWrongQuantitiesModalContent({
      title: 'Atenție!',
      description: 'Există o diferenţă între cantitatea asteptată şi cea introdusă.',
      buttons: [
        {
          label: 'Mai verific',
          onClick: () => {
            setIsWrongQuantitiesModalOpen(false)
            setTimeout(() => {
              document.getElementById('scan-input').focus()
            }, 0)
          },
          color: 'primary'
        },
        {
          label: 'Am terminat',
          onClick: () => {
            setIsWrongQuantitiesModalOpen(false)

            if (wrongDlc) {
              setIsWrongDlcAlertOpen(true)
            } else {
              formik.handleSubmit()
            }
          },
          color: 'primary'
        }
      ]
    })
    setIsWrongQuantitiesModalOpen(true)
  }

  const closeWrongQuantitiesMessage = () => {
    setIsWrongQuantitiesModalOpen(false)
  }

  const showProductScanMessage = msg => {
    setProductScanModalContent({
      title: 'Atenție!',
      description: msg,
      buttons: [
        {
          label: 'Ok',
          onClick: () => {
            setIsProductScanModalOpen(false)
            setTimeout(() => {
              document.getElementById('scan-input').focus()
            }, 0)
          },
          color: 'primary'
        }
      ]
    })
    setIsProductScanModalOpen(true)
  }

  const closeProductScanMessage = () => {
    setIsProductScanModalOpen(false)
  }

  const showShortLifeMessage = resp => {
    setShortLifeModalContent({
      title: 'Atenție!',
      description: "Produsul are durată de valabilitate scurtă!",
      buttons: [
        {
          label: 'Ok',
          onClick: () => {
            setIsShortLifeModalOpen(false)
            clearData()
            setConfirmResponse({ counter: resp.counter, total: resp.total })
            showNotification({
              message: 'Cantitaţile au fost înregistrate cu succes.',
              type: 'success'
            })
            setTimeout(() => {
              document.getElementById('scan-input').focus()
            }, 0)
          },
          color: 'primary'
        }
      ]
    })
    setIsShortLifeModalOpen(true)
  }

  const closeShortLifeMessage = () => {
    setIsShortLifeModalOpen(false)
  }

  const showSgrProductsList = sgrProducts => {
    setSgrProductsModalContent({
      title: 'Pe acest suport există produse SGR!',
      listItems: sgrProducts,
      buttons: [
        {
          label: 'Ok',
          onClick: () => {
            setIsSgrProductsModalOpen(false)
            setTimeout(() => {
              document.getElementById('scan-input').focus()
            }, 0)
          },
          color: 'primary'
        }
      ]
    })
    setIsSgrProductsModalOpen(true)
  }

  const closeSgrProductsModal = () => {
    setIsSgrProductsModalOpen(false)
  }

  const showSgrMessage = () => {
    setSgrMessageModalContent({
      title:
        'Acesta este un produs cu ambalaj returnabil - SGR! Va rugam sa gestionati aceste produs separat in vederea expunerii la raft.',
      buttons: [
        {
          label: 'Ok',
          onClick: () => {
            setIsSgrMessageModalOpen(false)
            setTimeout(() => document.getElementById("current-conform-input")?.focus(), 0)
          },
          color: 'primary'
        }
      ]
    })
    setIsSgrMessageModalOpen(true)
  }

  const closeSgrMessage = () => {
    setIsSgrMessageModalOpen(false)
  }

  const showCodeAndEanNotPresentConfirmation = (resp) => {
    setCodeAndEanNotPresentModalContent({
      title: 'Produsul nu a fost comandat. Continuaţi recepţia acestuia?',
      buttons: [
        {
          label: 'Da',
          onClick: () => {
            populateScanInfo(resp)
            setIsCodeAndEanNotPresentModalOpen(false)
            setTimeout(() => document.getElementById("current-conform-input")?.focus(), 0)
          },
          color: 'primary'
        },
        {
          label: 'Nu',
          onClick: () => {
            clearData()
            setIsCodeAndEanNotPresentModalOpen(false)
            setTimeout(() => {
              document.getElementById('scan-input').focus()
            }, 0)
          },
          color: 'secondary'
        }
      ]
    })
    setIsCodeAndEanNotPresentModalOpen(true)
  }

  const closeCodeAndEanNotPresentConfirmation = () => {
    setIsCodeAndEanNotPresentModalOpen(false)
  }

  const showEanNotPresentConfirmation = resp => {
    setEanNotPresentModalContent({
      title: 'EAN-ul nu există în fişierul de la depozit. Continuaţi recepţia acestuia?',
      buttons: [
        {
          label: 'Da',
          onClick: () => {
            populateScanInfo(resp)
            setIsEanNotPresentModalOpen(false)
            setTimeout(() => document.getElementById("current-conform-input")?.focus(), 0)
          },
          color: 'primary'
        },
        {
          label: 'Nu',
          onClick: () => {
            clearData()
            setIsEanNotPresentModalOpen(false)
            setTimeout(() => {
              document.getElementById('scan-input').focus()
            }, 0)
          },
          color: 'secondary'
        }
      ]
    })
    setIsEanNotPresentModalOpen(true)
  }

  const closeEanNotPresentConfirmation = () => {
    setIsEanNotPresentModalOpen(false)
  }

  return (
    <Grid
      gridContainerStyle={{ marginTop: '20px' }}
      maxWidth="xs"
      items={[
        <TitleHeader title="PRODUS ALEATOR VALIDARE LIVRARE" />,
        <Grid
          spacing={1}
          hasPaper={true}
          items={[
            <Typography variant="medium" component="p">
              PRODUS ALEATOR
            </Typography>,
            <Typography variant="medium" component="p">
              Număr înmatriculare: {support?.truckNumber}
            </Typography>,
            <Typography variant="medium" component="p">
              Suporți verificați: {support?.supportCounter} / {support?.totalSupportNumber}
            </Typography>
          ]}
          itemsPerRow={1}
        />,
        <Grid
          spacing={1}
          hasPaper={true}
          items={[
            <Typography variant="medium" component="p">
              Etichetă suport: {support?.supportCode}
            </Typography>,
            <Typography variant="medium" component="p">
              Număr suport: {support?.supportNumber}
            </Typography>,
            <Typography variant="medium" component="p">
              Produse verificate:{' '}
              {support?.productCounter > confirmResponse?.counter
                ? support?.productCounter
                : confirmResponse?.counter}
            </Typography>
          ]}
          itemsPerRow={1}
        />,
        support?.productList?.length > 0 &&
        <Autocomplete
          options={productOptions}
          value={selectedOption}
          inputValue={inputValue}
          onInputChange={(_e, newVal) => {
            setInputValue(newVal);
          }}
          onChange={(_e, newOption) => {
            const id = newOption?.value ?? ""
            formik.setFieldValue("bulkProductCode", id);
            productScanById(id);
          }}
          filterOptions={(opts, { inputValue }) =>
            opts.filter(o =>
              o.label.toLowerCase().includes(inputValue.toLowerCase())
            )
          }
          getOptionLabel={o => o.label}
          isOptionEqualToValue={(opt, val) => opt.value === val.value}
          renderInput={params => (
            <TextField
              {...params}
              label="Selectează produs vrac"
              variant="outlined"
              error={!!formik.errors.bulkProductCode}
              helperText={formik.errors.bulkProductCode as string}
              fullWidth
            />
          )}
          disableClearable
          autoHighlight
          fullWidth
        />,
        <div style={{ display: 'flex' }}>
          <TextField
            label="Cod Produs"
            variant="standard"
            fullWidth
            value={formik.values.productCode}
            onChange={event => formik.setFieldValue('productCode', event.target.value)}
            autoFocus
            onKeyUp={event => {
              if (event.which == 0) {
                if (
                  formik.values.productCode &&
                  validateScanCode(showNotification, formik.values.productCode, 'produs')
                )
                  productScan(support.supportId, formik.values.productCode)
              }
            }}
            id="scan-input"
            error={!!formik.errors.productCode}
            helperText={formik.errors.productCode ? String(formik.errors.productCode) : ''}
          />
          <IconButton
            onClick={() => {
              if (validateScanCode(showNotification, formik.values.productCode, 'produs')) {
                productScan(support.supportId, formik.values.productCode)
              }
            }}
          >
            <ManageSearchIcon />
          </IconButton>
        </div>,
        <Divider />,
        formik.values.productEans && (
          <>
            <FormTable columns={columns} rows={rows} />
            {litigation === 2 && (
              <ImageUpload
                uploadUrl={`/shop-reception-mobile/integral/upload/${support.supportId}/${formik.values.productId ?? formik.values.productCode}`}
                onSuccess={() => handleSuccess()}
                onError={handleError}
                btnStyle={{ color: imageUploaded ? 'green' : '#0970E6' }}
              />
            )}
            <DatePicker
              style={{ width: '100%' }}
              value={dayjs(formik.values.dlc)}
              onChange={value => formik.setFieldValue('dlc', value as Date | string)}
              hidden={!formik.values.showDlc}
              adapterLocale="ro"
              modalLabel="Selecteaza data"
              closeButtonLabel="Anuleaza"
              confirmButtonLabel="Confirma"
            />
          </>
        ),
        <>
          {showMarks && (
            <Input
              type="select"
              label="Marca"
              variant="outlined"
              width="100%"
              value={formik.values.mark}
              values={marks?.map(mark => ({ value: mark, label: mark }))}
              onChange={event => {
                formik.setFieldValue('mark', (event.target as HTMLInputElement).value)
                setShowDefects(true)
              }}
            />
          )}
          {showDefects && (
            <Input
              type="select"
              label="Motiv"
              variant="outlined"
              width="100%"
              value={formik.values.defectReason}
              defaultValue={productScanResp?.defectReason}
              values={defectReasons?.map(defect => ({ value: defect, label: defect }))}
              onChange={event => {
                formik.setFieldValue('defectReason', (event.target as HTMLInputElement).value)
              }}
              disabled={formik.values.mark === ''}
            />
          )}
        </>,
        formik.values.productEans && (
          <Button
            type="button"
            variant="contained"
            label="CONFIRMĂ CANTITĂȚI"
            onClick={() => confirmProduct()}
            style={{ width: '100%' }}
            disabled={
              (litigation === 2 &&
                (!imageUploaded ||
                  formik.values.mark === '' ||
                  formik.values.defectReason === '')) ||
              (litigation === 1 &&
                (formik.values.mark === '' || formik.values.defectReason === '')) ||
              formik.isSubmitting
            }
          />
        ),
        showModificaButton && (
          <Button
            type="button"
            variant="contained"
            label="Modifică cantităţi"
            onClick={modifyQuantities}
            style={{ width: '100%' }}
          />
        ),
        !formik.values.productEans && (
          <Button
            type="button"
            variant="contained"
            label="FINALIZEAZĂ SUPORT"
            onClick={() => onFinalize()}
            style={{ width: '100%' }}
          />
        ),
        <>
          <AlertModal
            open={isWrongQuantitiesModalOpen}
            handleClose={closeWrongQuantitiesMessage}
            title={wrongQuantitiesModalContent.title}
            description={wrongQuantitiesModalContent.description}
            buttons={wrongQuantitiesModalContent.buttons}
          />
          <AlertModal
            open={isMandatoryDlcAlertOpen}
            handleClose={() => setIsMandatoryDlcAlertOpen(false)}
            title={'Atentie'}
            description={'Data limită de consum este obligatorie!'}
            buttons={[
              { label: 'Ok', onClick: () => setIsMandatoryDlcAlertOpen(false), color: 'primary' }
            ]}
          />
          <AlertModal
            open={isWrongDlcAlertOpen}
            handleClose={() => setIsWrongDlcAlertOpen(false)}
            title={'Atentie'}
            description={'Există diferenţe între DLC asteptat şi cel introdus.'}
            buttons={[
              {
                label: 'Mai verific',
                onClick: () => {
                  setIsWrongDlcAlertOpen(false)
                  setTimeout(() => {
                    document.getElementById('scan-input').focus()
                  }, 0)
                },
                color: 'primary'
              },
              {
                label: 'Am terminat',
                onClick: () => {
                  formik.handleSubmit()
                  setIsWrongDlcAlertOpen(false)
                },
                color: 'primary'
              }
            ]}
          />
          <AlertModal
            open={isSgrProductsModalOpen}
            handleClose={closeSgrProductsModal}
            title={sgrProductsModalContent.title}
            listItems={sgrProductsModalContent.listItems}
            buttons={sgrProductsModalContent.buttons}
          />
          <AlertModal
            open={isProductScanModalOpen}
            handleClose={closeProductScanMessage}
            title={productScanModalContent.title}
            description={productScanModalContent.description}
            buttons={productScanModalContent.buttons}
          />
          <AlertModal
            open={isCodeAndEanNotPresentModalOpen}
            handleClose={closeCodeAndEanNotPresentConfirmation}
            title={codeAndEanNotPresentModalContent.title}
            buttons={codeAndEanNotPresentModalContent.buttons}
          />
          <AlertModal
            open={isEanNotPresentModalOpen}
            handleClose={closeEanNotPresentConfirmation}
            title={eanNotPresentModalContent.title}
            buttons={eanNotPresentModalContent.buttons}
          />
          <AlertModal
            open={isSgrMessageModalOpen}
            handleClose={closeSgrMessage}
            title={sgrMessageModalContent.title}
            buttons={sgrMessageModalContent.buttons}
          />
          <AlertModal
            open={isConfirmFinaliseSupportModalOpen}
            handleClose={closeConfirmFinaliseSupport}
            title={confirmFinaliseSupportModalContent.title}
            buttons={confirmFinaliseSupportModalContent.buttons}
          />
          <AlertModal
            open={isShortLifeModalOpen}
            handleClose={closeShortLifeMessage}
            title={shortLifeModalContent.title}
            description={shortLifeModalContent.description}
            buttons={shortLifeModalContent.buttons}
          />
        </>
      ]}
      itemsPerRow={1}
    />
  )
}
export default DeliveryRandomProductFinal
